// src/components/common/SectionTitle.jsx

import React from "react";

const SectionTitle = ({
  eyebrow,
  title,
  subtitle,
  align = "left",
  className = "",
  eyebrowIcon: EyebrowIcon,
  action,
  animate = true,
  descriptionWidth = "max-w-2xl",
}) => {
  const isCenter = align === "center";

  const alignCls = isCenter
    ? "items-center text-center"
    : "items-start text-left";

  return (
    <div
      className={`
        flex w-full flex-col
        gap-3
        ${alignCls}
        ${animate ? "njv-section-title" : ""}
        ${className}
      `}
    >
      {/* =====================================================
          EYEBROW
      ====================================================== */}
      {eyebrow && (
        <div
          className={`
            inline-flex items-center gap-2
            rounded-full
            border border-[#00A260]/15
            bg-[#00A260]/8
            px-3.5 py-1.5
            text-[10px] font-bold uppercase
            tracking-[0.16em]
            text-[#008C54]
            sm:px-4 sm:py-2
            sm:text-xs
          `}
        >
          {/* Accent dot */}
          <span
            className="
              relative flex h-2 w-2 shrink-0
              items-center justify-center
            "
          >
            <span
              className="
                absolute h-2 w-2
                animate-ping
                rounded-full
                bg-[#00C878]/40
              "
            />

            <span
              className="
                relative h-1.5 w-1.5
                rounded-full
                bg-[#00A260]
              "
            />
          </span>

          {EyebrowIcon && (
            <EyebrowIcon
              className="h-3.5 w-3.5"
              aria-hidden="true"
            />
          )}

          <span>{eyebrow}</span>
        </div>
      )}

      {/* =====================================================
          TITLE + OPTIONAL ACTION
      ====================================================== */}
      <div
        className={`
          w-full
          ${
            action
              ? "flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between"
              : ""
          }
        `}
      >
        {/* Heading */}
        <div>
          <h2
            className="
              text-[28px]
              font-extrabold
              leading-[1.08]
              tracking-[-0.035em]
              text-[#061A3A]
              sm:text-3xl
              lg:text-4xl
          "
          >
            {title}
          </h2>

          {/* Green accent line */}
          {!isCenter && (
            <div className="mt-3 flex items-center gap-1.5">
              <span className="h-1 w-8 rounded-full bg-[#00A260]" />
              <span className="h-1 w-2 rounded-full bg-[#8BF108]" />
            </div>
          )}
        </div>

        {/* Optional action */}
        {action && (
          <div className="shrink-0">
            {action}
          </div>
        )}
      </div>

      {/* =====================================================
          SUBTITLE
      ====================================================== */}
      {subtitle && (
        <p
          className={`
            ${descriptionWidth}
            text-sm
            leading-6
            text-[#64748B]
            sm:text-base
            sm:leading-7
          `}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionTitle;